import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { classNames } from 'primereact/utils';
import { Route, Routes, useLocation } from 'react-router-dom';

import AppTopBar from './AppTopbar';
import AppFooter from './AppFooter';
import AppMenu from './AppMenu';
import AppInlineProfile from './AppInlineProfile';
import ReportIssueButton from './common/ReportIssue/ReportIssueButton';
import IssueReportsList from './common/ReportIssue/IssueReportsList';

import InstitutionSales from './Institute/InstitutionSales';
import OrderList from './Institute/OrderList';
import OrderView from './Institute/OrderView';
import OrderEdit from './Institute/OrderEdit';
import AssignProduct from './masters/AssignProduct';
import ViewAssignedProduct from './masters/ViewAssignedProduct';
import Parentmasters from './masters/Parentmasters';
import Submasters from './masters/Submasters';
import LiveData from './masters/LiveData';
import Newbranch from './masters/Newbranch';
import Datapushing from './masters/Datapushing';
import BranchTables from './masters/BranchTables';
import GsbillingEndpoints from './masters/GsbillingEndpoints';
import VikrayaEndpoints from './masters/VikrayaEndpoints';
import RootsalesEndpoints from './masters/RootsalesEndpoints';
import SantheEndpoints from './masters/SantheEndpoints';
import ApiEndpoints from './masters/ApiEndpoints';
import Clientreportchecking from './masters/Clientreportchecking';
import Location from './masters/Location';
import CategoryMaster from './masters/CategoryMaster';
import ProductCategory from './masters/ProductCategory';
import ProductMaster from './masters/ProductMaster';
import ProductList from './masters/ProductList';
import ProductEdit from './masters/ProductEdit';
import ProductMultiBranch from './masters/ProductMultiBranch';
import ProductMultiBranchList from './masters/ProductMultiBranchList';
import Settings from './masters/Settings';
import ApplicationSetting from './masters/ApplicationSetting';
import Clients from './masters/Clients';
import Branch from './masters/Branch';
import BranchList from './masters/BranchList';
import BranchEdit from './masters/BranchEdit';
import Users from './masters/Users';
import Masters from './masters/Masters';
import MasterList from './masters/MasterList';
import SmsManage from './masters/SmsManage';
import SmsDetailList from './masters/SmsDetailList';
import Uom from './masters/Uom';
import TaxPercent from './masters/TaxPercent';
import Platform from './masters/Platform';
import Company from './masters/Company';
import ModuleGroup from './masters/ModuleGroup';
import ModuleMenu from './masters/ModuleMenu';
import UserModules from './masters/UserModules';
import Roles from './masters/Roles';
import Sections from './masters/Sections';
import Notifications from './services/Notifications';
import Mobilebillingapp from './services/Mobilebillingapp';
import TaxInvoicePage from './invoices/TaxInvoicePage';
import BuyerMaster from './invoices/BuyerMaster';
import SellerMaster from './invoices/SellerMaster';
import CategoryDialog from './masters/CategoryDialog';
import CategoryproductDialog from './masters/CategoryproductDialog';
import Feedback from './masters/Feedback';

import ItemReports from './components/reports/itemreports';
import ItemOnlineReports from './components/reports/itemOnlineReport/itemOnlineReports';
import BillView from './components/ceo/BillView';
import SalesReport from './components/ceo/SalesReport';

import BillReports from './components/reports/billreports';
import CreditReports from './components/reports/creditreport';
import CreditSettlementReports from './components/reports/creditsettlementreport';
import AdvanceReports from './components/reports/advanceReport/advanceReports';
import BillViewReceipt from './components/reports/BillViewReceipt';
import SalesReports from './components/reports/salesreports';
import SalesReporta from './components/reports/salesreporta';
import CategoryWiseReports from './components/reports/categorywisereports';
import CategoryOnlineReports from './components/reports/categoryOnlineReport/categoryOnlineReports';
import WaiterReport from './components/reports/WaiterReport';
import SalesByWaiters from './components/reports/salesbywaiters';
import SessionSales from './components/reports/sessionsales';
import CashierSales from './components/reports/cashiersales';
import Dashboard from './components/Dashboard';
import ClearData from './components/ClearData';
import ExcelExport from './components/ExcelExport';

import AddVoucher from './vouchers/AddVoucher';
import VoucherList from './vouchers/VoucherList';
import AddExpense from './expenses/AddExpense';
import ExpensesList from './expenses/ExpensesList';

import OdcEdit from './ODC/OdcEdit';
import OdcList from './ODC/OdcList';
import OdcView from './ODC/OdcView';
import OdcSales from './ODC/OdcSales';
import POSDashboard from './Counter/POSDashboard';

import PrimeReact from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './App.scss';

import useUser from './hooks/useUser';
import { getUserMenu } from './utilities/api';

const App = () => {
    const [rotateMenuButton, setRotateMenuButton] = useState(false);
    const [menuActive, setMenuActive] = useState(false);
    const [profileMode, setProfileMode] = useState('inline');
    const [profileExpanded, setProfileExpanded] = useState(false);
    // Use overlay menu on smaller screens by default, static on large screens
    const [menuMode, setMenuMode] = useState(() => (typeof window !== 'undefined' && window.innerWidth <= 1024 ? 'overlay' : 'static'));
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [topbarMenuActive, setTopbarMenuActive] = useState(false);
    const [activeTopbarItem, setActiveTopbarItem] = useState(null);
    const [darkMenu, setDarkMenu] = useState(false);
    const [theme, setTheme] = useState('purple');
    const [layout, setLayout] = useState('purple');
    const [layoutScheme, setLayoutScheme] = useState('light');
    const [configActive, setConfigActive] = useState(false);
    const [inputStyle, setInputStyle] = useState('filled');
    const [ripple, setRipple] = useState(false);
    const copyTooltipRef = useRef();
    const location = useLocation();

    const [menu, setMenu] = useState([]);
    const { loggedInUser } = useUser();

    let menuClick = false;
    let topbarItemClick = false;
    let configClick = false;

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    // Fetch dynamic menu
    useEffect(() => {
        if (loggedInUser) {
            getUserMenu(loggedInUser)
                .then((groups) => {
                    const normalized = (groups || []).map((group) => ({
                        label: group.label || group.module_group_name || 'Menu',
                        icon: group.icon || group.group_icon || '',
                        items: (group.items || []).map((item) => ({
                            label: item.label || item.module_name || 'Item',
                            icon: item.icon || item.menu_icon || '',
                            to: item.to || item.url || item.link || ''
                        }))
                    }));
                    setMenu(normalized);
                })
                .catch((err) => console.error('Error fetching menu:', err));
        }
    }, [loggedInUser]);

    const onMenuitemClick = (event) => {
        if (!event.item.items) {
            hideOverlayMenu();
        }
        if (!event.item.items && (menuMode === 'slim' || menuMode === 'horizontal')) {
            setMenuActive(false);
        }
    };

    const onRootMenuitemClick = () => {
        setMenuActive((prev) => !prev);
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;
        setRotateMenuButton((prev) => !prev);
        setTopbarMenuActive(false);

        if (menuMode === 'overlay') {
            setOverlayMenuActive((prev) => !prev);
        } else {
            if (isDesktop()) setStaticMenuDesktopInactive((prev) => !prev);
            else setStaticMenuMobileActive((prev) => !prev);
        }

        event.preventDefault();
    };

    const onDocumentClick = () => {
        if (!topbarItemClick) {
            setActiveTopbarItem(null);
            setTopbarMenuActive(false);
        }
        if (!menuClick) {
            if (menuMode === 'horizontal' || menuMode === 'slim') setMenuActive(false);
            hideOverlayMenu();
        }
        if (configActive && !configClick) setConfigActive(false);

        menuClick = false;
        topbarItemClick = false;
        configClick = false;
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setRotateMenuButton(false);
        setStaticMenuMobileActive(false);
    };

    const isDesktop = () => window.innerWidth > 1024;

    const isMenuVisible = () => {
        if (isDesktop()) {
            return menuMode === 'overlay' ? overlayMenuActive : !staticMenuDesktopInactive;
        } else {
            return menuMode === 'overlay' ? overlayMenuActive : staticMenuMobileActive;
        }
    };

    const containerClassName = classNames('layout-wrapper', {
        'menu-layout-static': menuMode !== 'overlay',
        'menu-layout-overlay': menuMode === 'overlay',
        'layout-menu-overlay-active': overlayMenuActive,
        'menu-layout-slim': menuMode === 'slim',
        'menu-layout-horizontal': menuMode === 'horizontal',
        'layout-menu-static-inactive': staticMenuDesktopInactive,
        'layout-menu-static-active': staticMenuMobileActive,
        'p-input-filled': inputStyle === 'filled',
        'p-ripple-disabled': !ripple
    });

    const menuClassName = classNames('layout-menu-container', {
        'layout-menu-dark': darkMenu,
        'layout-menu-container-inactive': !isMenuVisible()
    });

    return (
        <div className={containerClassName} onClick={onDocumentClick}>
            <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />
            <ReportIssueButton />

            <div className="layout-wrapper-content">
                <AppTopBar topbarMenuActive={topbarMenuActive} profileMode={profileMode} horizontal={menuMode === 'horizontal'} activeTopbarItem={activeTopbarItem} rotateMenuButton={rotateMenuButton} onMenuButtonClick={onMenuButtonClick} />

                <div className={menuClassName} onClick={() => (menuClick = true)}>
                    <div className="menu-scroll-content">
                        {profileMode === 'inline' && menuMode !== 'horizontal' && <AppInlineProfile onProfileClick={() => setProfileExpanded((prev) => !prev)} expanded={profileExpanded} />}
                        <AppMenu model={menu} menuMode={menuMode} active={menuActive} onMenuitemClick={onMenuitemClick} onRootMenuitemClick={onRootMenuitemClick} />
                    </div>
                </div>

                <div className="layout-main">
                    <Routes>
                        <Route path="/institutionsales" element={<InstitutionSales />} />
                        <Route path="/orderlist" element={<OrderList />} />
                        <Route path="/orderview/:id" element={<OrderView />} />
                        <Route path="/orderedit/:id" element={<OrderEdit />} />
                        <Route path="/assignproduct" element={<AssignProduct />} />
                        <Route path="/viewassignedproduct" element={<ViewAssignedProduct />} />
                        <Route path="/feedback" element={<Feedback />} />
                        <Route path="/itemreport" element={<ItemReports />} />
                        <Route path="/itemonlinereport" element={<ItemOnlineReports />} />
                        <Route path="/salesreport" element={<SalesReport />} />
                        <Route path="/billreport" element={<BillReports />} />
                        <Route path="/billview/:id" element={<BillView />} />
                        <Route path="/location" element={<Location />} />
                        <Route path="/categorymaster" element={<CategoryMaster />} />
                        <Route path="/productcategory" element={<ProductCategory />} />
                        <Route path="/productmaster" element={<ProductMaster />} />
                        <Route path="/productlist" element={<ProductList />} />
                        <Route path="/productedit/:id" element={<ProductEdit />} />
                        <Route path="/productmultibranch" element={<ProductMultiBranch />} />
                        <Route path="/productmultibranchlist" element={<ProductMultiBranchList />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/applicationsetting" element={<ApplicationSetting />} />
                        <Route path="/clients" element={<Clients />} />
                        <Route path="/branch" element={<Branch />} />
                        <Route path="/branchlist" element={<BranchList />} />
                        <Route path="/branchedit/:id" element={<BranchEdit />} />
                        <Route path="/users" element={<Users />} />
                        <Route path="/masters" element={<Masters />} />
                        <Route path="/masterlist" element={<MasterList />} />
                        <Route path="/smsmanage" element={<SmsManage />} />
                        <Route path="/smsdetaillist" element={<SmsDetailList />} />
                        <Route path="/uom" element={<Uom />} />
                        <Route path="/taxpercent" element={<TaxPercent />} />
                        <Route path="/platform" element={<Platform />} />
                        <Route path="/company" element={<Company />} />
                        <Route path="/newbranch" element={<Newbranch />} />
                        <Route path="/datapushing" element={<Datapushing />} />
                        <Route path="/branchtables" element={<BranchTables />} />
                        <Route path="/modulegroup" element={<ModuleGroup />} />
                        <Route path="/modulemenu" element={<ModuleMenu />} />
                        <Route path="/usermodules" element={<UserModules />} />
                        <Route path="/roles" element={<Roles />} />
                        <Route path="/sections" element={<Sections />} />
                        <Route path="/notifications" element={<Notifications />} />
                        <Route path="/taxinvoice" element={<TaxInvoicePage />} />
                        <Route path="/buyermaster" element={<BuyerMaster />} />
                        <Route path="/sellermaster" element={<SellerMaster />} />
                        <Route path="/mobilebillingapp" element={<Mobilebillingapp />} />
                        <Route path="/billreports" element={<BillReports />} />
                        <Route path="/creditreport" element={<CreditReports />} />
                        <Route path="/creditsettelementreport" element={<CreditSettlementReports />} />
                        <Route path="/excelexport" element={<ExcelExport />} />
                        <Route path="/advancereport" element={<AdvanceReports />} />
                        <Route path="/billreceipt/:id/:branchId" element={<BillViewReceipt />} />
                        <Route path="/salesreports" element={<SalesReports />} />
                        <Route path="/salesreporta" element={<SalesReporta />} />
                        <Route path="/categorywisereports" element={<CategoryWiseReports />} />
                        <Route path="/categoryonlinereport" element={<CategoryOnlineReports />} />
                        <Route path="/waiterreport" element={<WaiterReport />} />
                        <Route path="/salesbywaiters" element={<SalesByWaiters />} />
                        <Route path="/sessionsales" element={<SessionSales />} />
                        <Route path="/cashiersales" element={<CashierSales />} />
                        <Route path="/dashboardTest" element={<Dashboard />} />
                        <Route path="/cleardata" element={<ClearData />} />
                        <Route path="/voucheradd" element={<AddVoucher />} />
                        <Route path="/voucherlist" element={<VoucherList />} />
                        <Route path="/expenseadd" element={<AddExpense />} />
                        <Route path="/expenseslist" element={<ExpensesList />} />
                        <Route path="/categorydialog" element={<CategoryDialog />} />
                        <Route path="/categoryproductdialog" element={<CategoryproductDialog />} />
                        <Route path="/odcedit" element={<OdcEdit />} />
                        <Route path="/odcedit/:id" element={<OdcEdit />} />
                        <Route path="/odclist" element={<OdcList />} />
                        <Route path="/odcorderlist" element={<OdcList />} />
                        <Route path="/odcview" element={<OdcView />} />
                        <Route path="/odcsales" element={<OdcSales />} />
                        <Route path="/ordcsales" element={<OdcSales />} />
                        <Route path="/parentmasters" element={<Parentmasters />} />
                        <Route path="/submasters" element={<Submasters />} />
                        <Route path="/issue-reports" element={<IssueReportsList />} />
                        <Route path="/livedata" element={<LiveData />} />
                        <Route path="/gsbillingendpoints" element={<GsbillingEndpoints />} />
                        <Route path="/vikrayaendpoints" element={<VikrayaEndpoints />} />
                        <Route path="/rootsalesendpoints" element={<RootsalesEndpoints />} />
                        <Route path="/santheendpoints" element={<SantheEndpoints />} />
                        <Route path="/apiendpoints" element={<ApiEndpoints />} />
                        <Route path="/clientreportchecking" element={<Clientreportchecking />} />
                        <Route path="/POSDashboard" element={<POSDashboard />} />
                    </Routes>
                </div>

                <AppFooter layoutScheme="light" />
            </div>
        </div>
    );
};

export default App;
